/**
 * The issue form fields a company can show/hide/require. Mirrors
 * `IssueFormField` in the backend's `issues/consts_fields.py` — values are the
 * Issue model field names.
 */
export const IssueFormField = {
  TITLE: 'title',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  SEVERITY: 'severity',
  RISK_ASPECT: 'risk_aspect',
  PROCESS_CHOICE: 'process_choice',
  RESPONSIBLE_USER: 'responsible_user',
  CASE_HANDLER: 'case_handler',
  TAGS: 'tags',
  TIME_OF_ISSUE: 'time_of_issue',

  LOCATION_PLACENAME: 'location_placename',
  LOCATION_DESCRIPTION: 'location_description',
  VEHICLE_PLATE_NUMBER: 'vehicle_plate_number',

  ISSUE_DESCRIPTION: 'issue_description',
  DAMAGE_DESCRIPTION: 'damage_description',
  REASON: 'reason',

  IMMEDIATE_ACTION: 'immediate_action',
  ACTION: 'action',
  SOLUTION_SUGGESTION: 'solution_suggestion',

  COST_ESTIMATION: 'cost_estimation',
  ATTACHMENTS: 'attachments',
} as const

export type IssueFormFieldValue =
  (typeof IssueFormField)[keyof typeof IssueFormField]

export const IssueFormSection = {
  META: 'META',
  LOCATION: 'LOCATION',
  EVENT: 'EVENT',
  RESOLUTION: 'RESOLUTION',
  COST: 'COST',
} as const

export type IssueFormSectionValue =
  (typeof IssueFormSection)[keyof typeof IssueFormSection]

/** One field as the company has it configured, plus its code-level limits. */
export interface IssueFieldConfig {
  field: IssueFormFieldValue
  section: IssueFormSectionValue
  order: number
  labelOverride: string
  visibleOnCreate: boolean
  requiredOnCreate: boolean
  visibleOnEdit: boolean
  requiredOnEdit: boolean
  canHide: boolean
  canRequire: boolean
}

export interface IssueFieldConfigsQuery {
  issueFieldConfigs: IssueFieldConfig[]
}

/** Which half of the flow a field is being rendered for. */
export type IssueFormMode = 'create' | 'edit'

export interface SetIssueFieldConfigsInput {
  field: IssueFormFieldValue
  visibleOnCreate?: boolean
  requiredOnCreate?: boolean
  visibleOnEdit?: boolean
  requiredOnEdit?: boolean
  order?: number
  labelOverride?: string
}
